import L from "leaflet";

const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = ""
) => {
  //---------------allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    let isInCluster = false;
    const clusterChildMarkers = cluster.getAllChildMarkers();
    if (selectedInstitution) {
      for (const clusterChildMarker of clusterChildMarkers) {
        if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
          isInCluster = true;
          //cluster.spiderfy();
        }
      }
    }

    return L.divIcon({
      // Cluster icon
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
              <circle id="Ellipse_3" data-name="Ellipse 3" cx="22" cy="22" r="22"/>
            </svg>
            <div class="cluster-icon__child-count">${cluster.getChildCount()}</div>
            `,
      iconSize: L.point(35, 35, true),
      iconAnchor: [17, 17],
      className: "custom-marker-cluster",
    });
  } else {
    // One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin`,
      iconSize: [30, 30], // size of the icon
      iconAnchor: [15, 30],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -36],
      html: ` <div class="markerIcon leaflet-marker-icon">
      <svg class="${
        isSelected ? "active" : ""
      }" version="1.1" id="Calque_1" xmlns:serif="http://www.serif.com/"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
      width="40px" height="40px"
      xml:space="preserve">
        <path class="st0" d="M20,2.6c-7.2,0-13.3,5.8-13.3,13.3c0,3,2.1,7.4,6,13c3,4,6,7.2,6,7.4l1.2,1.2l1.2-1.2c0.2-0.2,3-3.3,6-7.4
          c4.2-5.6,6-10,6-13C33.3,8.4,27.2,2.6,20,2.6z M20,20.5c-2.6,0-4.9-2.1-4.9-4.9s2.1-4.9,4.9-4.9s4.9,2.1,4.9,4.9S22.6,20.5,20,20.5z
          "/>
      </svg>
    </div>
    `,
    });
    return icon1;
  }
};

export default MarkerIcon;
